const firebaseConfig = {
  apiKey: "AIzaSyCBDbJV354r6WAOLEschUhMzEZV_KMm8Kg",
  authDomain: "purchase-5e148.firebaseapp.com",
  projectId: "purchase-5e148",
  storageBucket: "purchase-5e148.appspot.com",
  messagingSenderId: "544748549391",
  appId: "1:544748549391:web:e9d1fe968b9ca8c3d2ba7a"
};

export default firebaseConfig;
